import '@/assets/css/style.css'
import '@/assets/js/media_750'
import vant from 'vant'
import 'vant/lib/index.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.use(vant)

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
// const errorHandler = (error, vm) => {
//   // console.error('抛出全局异常');
//   // console.error(vm);
//   // console.error(error);
//   alert(error);
//   alert(JSON.stringify(error));
//   alert(vm);
//   alert(JSON.stringify(vm));
// };

// Vue.config.errorHandler = errorHandler;
// Vue.prototype.$throw = (error) => errorHandler(error, this);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
